import tmpl from './form.phtml';
import View from 'lib/View';
import config from 'config';
import b64toblob from 'b64-to-blob';
import loadImage from 'blueimp-load-image';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
// import EXIF from 'exif-js';



export default View.extend({
	template: tmpl,


	events: {
		'change input:file': 'showImage',
		'focus textarea': 'scrollToEventTarget',

		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',

		'click .js-delete-image': 'deleteImage',
		'click .js-take-picture': 'takePicture',
		'click .js-open-library': 'openLibrary',
	},

	_pic: function( source )
	{
		var options = {
			quality: Math.round( 100 * config.image.quality ),
			allowEditing: false,
			resultType: CameraResultType.Uri,
			source: source,
			width: config.image.size,
			height: config.image.size,
			correctOrientation: true,
			saveToGallery: true,
		};

		Camera.getPhoto( options ).then( _.bind( function( photo )
		{
			this.saveImage( photo.webPath || photo.path );
		}, this ) ).catch( app.warn );
	},

	openLibrary: function()
	{
		this._pic( CameraSource.Photos );
	},

	takePicture: function()
	{
		this._pic( CameraSource.Camera );
	},

	showImage: function( evt )
	{
		// Aucun fichier fourni
		if( !evt.target.files || evt.target.files.length < 1 )
		{
			this.model.setErrors({ name: 'Aucun fichier sélectionné' });
			return this.render();
		}

		var file = evt.target.files[0];

		// Fichier n'est pas une image
		if( !/^image\//.test( file.type ) )
		{
			this.model.setErrors({ name: 'Veuillez choisir une photo' });
			return this.render();
		}

		this.saveImage( file );
	},


	// Sauvegarde l'image sélectionnée en cache en la convertissant en JPEG 1600x1600 max
	// Et renseigne les champs de l'objet image (le model)
	saveImage: function( image )
	{
		var read = this.readAsBlob( image );
		read.done( _.bind( function( blob )
		{
			var write = app.storage.write( 'image', this.model.getPath(), blob );
			write.done( _.bind( function( blob ) 
			{ 
				if( this.model.src ) {
					URL.revokeObjectURL( this.model.src );
				}

				var src = URL.createObjectURL( blob );
				this.model.src = src;
				this.model.set({
					name: _.isString( image ) ?  _.last( image.split('/') ) : (image.name || this.model.get('uuid')+'.jpg'), // Nom du fichier par défaut = UUID.jpg
				});

				this.render();
			}, this ));

			write.fail( function( err) {
				console.error(err);
				app.addMessage("Erreur lors de la sauvegarde de la photo","error");
			});
		}, this ));


		read.fail( function(err) { 
			app.addMessage( "Erreur lors du chargement de la photo…", "error" ); 
		});
	},

	readAsBlob: function( image )
	{
		var deferred = $.Deferred();

		// si image est un blob, on le retourne
		if( image instanceof Blob )
		{
			deferred.resolve( image );
			return deferred;
		}

		// Si fichier local, récupérer son URL locale
		if( image instanceof File ) 
		{
			image  = image.localURL;
		}


		// si URL (http, capacitor, file, content, blob), la lire via fetch
		if( _.isString( image ) && image.match( /^(https?|capacitor|file|content|blob):/ ) )
		{
			fetch( image ).then(function( response )
			{
				return response.blob();
			}).then( deferred.resolve ).catch( deferred.reject );
			return deferred;
		}


		// DATA_URL / base64 brut (préfixe data: à retirer avant atob)
		if( _.isString( image ) )
		{
			var b64 = image.replace( /^data:[^;]+;base64,/, '' );
			deferred.resolve( b64toblob( b64, 'image/jpeg' ) );
			return deferred;
		}

		deferred.reject('Situation impossible ?')
		return deferred;
	},


/*
	readExif: function( src )
	{
		var deferred = $.Deferred();

		var xhr = new XMLHttpRequest();
		xhr.open( 'GET', src, true );
		xhr.responseType = 'arraybuffer';

		xhr.onload = function()
		{
			deferred.resolve( EXIF.readFromBinaryFile( this.response ) );
		};

		xhr.onerror = deferred.reject;
		xhr.onabort = deferred.reject;

		xhr.send();

		return deferred;
	},
*/

	onSubmit: function( evt )
	{
		evt.preventDefault();

		// Validation des données
		var data = this.$('form').serializeJSON();
		this.$(':input, button').prop('disabled',true);

		this.model.set( data );

		if( !this.model.isValid() )
		{
			return this.render();
		}

		// écriture en dur et on roule
		var save = this.model.saveSrc();
		app.addMessage( "Enregistrement de la photo", save );

		save.done(_.bind( function()
		{
			// Je suis en train d'ajouter une image à un signalement ou de la modifier
			if( !this.model.has( 'id' ) || this.model.get( 'todo' ) === 'create' )
			{
				this.model.set('todo','create');
			}
			else
			{
				this.model.set('todo','update');
			}

			var self = this;
			app.persistModel( this.model ).then( function()
			{
				app.set('locked',false);
				app.commit();
				app.redirect( self.model.getPond().toUrl('pond/view') );
			} );
		},this));

		save.fail(function()
		{
			app.addMessage( "L'enregistrement de la photo à échouée", 'error' );
		});
	},

	deleteImage: function( evt )
	{
		this.$(evt.target).closest('.modal').modal('hide');

		this.model.set('todo','delete');
		app.persistModel( this.model ).then( function()
		{
			app.commit();
		} );
		app.set('locked',false);

		var pond = this.model.getPond();
		app.redirect( pond ? pond.toUrl('pond/view') : 'user/index' );
	},

	render: function()
	{
		this.doRender({
			image: this.model,
			pond: this.model.getPond()
		});
	}
});
